import { useEffect, useRef, useState } from 'react';
import { NavLink, Outlet } from 'react-router';
import { SelectorIdioma } from '../ui/SelectorIdioma';
import { tx } from '../i18n';
import { useSesion } from '../sesion/sesion';
import { Marca } from '../ui/Logo';

/** Las iniciales de la persona, para el botón redondo de la barra. */
const iniciales = (nombre: string) =>
  nombre
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('') || '?';

function MenuUsuario() {
  const { usuario, salir } = useSesion();
  const [abierto, setAbierto] = useState(false);
  const caja = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!abierto) return;
    const afuera = (e: MouseEvent) => {
      if (!caja.current?.contains(e.target as Node)) setAbierto(false);
    };
    const esc = (e: KeyboardEvent) => e.key === 'Escape' && setAbierto(false);
    document.addEventListener('mousedown', afuera);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', afuera);
      document.removeEventListener('keydown', esc);
    };
  }, [abierto]);
  if (!usuario) return null;
  return (
    <div className="menu-usuario" ref={caja}>
      <button type="button" className="usuario" onClick={() => setAbierto((v) => !v)} aria-expanded={abierto} aria-haspopup="menu">
        <i>{iniciales(usuario.nombre)}</i>
        <span>{tx.comun.roles[usuario.rol] ?? usuario.rol}</span>
      </button>
      {abierto && (
        <div className="flotante menu-usuario-menu" role="menu">
          <div className="quien">
            <b>{usuario.nombre}</b>
            <small>{usuario.correo}</small>
            <small>{tx.comun.roles[usuario.rol] ?? usuario.rol}</small>
          </div>
          <button type="button" className="menu-item" role="menuitem" onClick={() => void salir()}>
            {tx.marco.salir}
          </button>
        </div>
      )}
    </div>
  );
}

/** El marco del panel: la marca, las pantallas y quién está adentro. */
export function Marco() {
  return (
    <div className="app">
      <header className="barra">
        {/* La barra pinta de lado a lado, pero su contenido se alinea con el de la página:
            si no, en un monitor ancho el logo queda a 300px del primer panel. */}
        <div className="barra-dentro">
          <Marca />
          <nav className="nav" aria-label={tx.marco.pantallas}>
            <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>
              {tx.marco.tablero}
            </NavLink>
            <NavLink to="/appliances" className={({ isActive }) => (isActive ? 'active' : '')}>
              {tx.marco.appliances}
            </NavLink>
            <NavLink to="/red" className={({ isActive }) => (isActive ? 'active' : '')}>
              {tx.marco.red}
            </NavLink>
            <NavLink to="/ajustes" className={({ isActive }) => (isActive ? 'active' : '')}>
              {tx.marco.ajustes}
            </NavLink>
          </nav>
          <div className="barra-der">
            <SelectorIdioma />
            <MenuUsuario />
          </div>
        </div>
      </header>
      <main className="contenido">
        <Outlet />
      </main>
    </div>
  );
}
